import { getLocalStorage, setLocalStorage } from "utils/storage";

const ID_TOKEN_COOKIE = "idToken";

class AuthStorage {
  private _token: string;

  constructor() {
    this._token = getLocalStorage(ID_TOKEN_COOKIE, null);
  }

  get token() {
    return this._token;
  }

  set token(token: string) {
    this._token = token;
    setLocalStorage(ID_TOKEN_COOKIE, token);
  }
}

export const authStorage = new AuthStorage();
